import { render, staticRenderFns } from "./DFNumeric.vue?vue&type=template&id=9d9a9bc6&"
import script from "./DFNumeric.vue?vue&type=script&lang=js&"
export * from "./DFNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports